import React, { useState } from "react";
import PropTypes from "prop-types";
import Truncate from "react-truncate";

const ReadMore = (props) => {
  const { children, more, less, lines } = props;

  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setTruncated] = useState(false);

  const handleTruncate = (truncated) => {
    if (isTruncated !== truncated) {
      setTruncated(truncated);
    }
  };

  const toggleLines = (event) => {
    event.preventDefault();
    setExpanded(!expanded);
  };
  const isCharacterDownTheLine = () => {
    return children.indexOf("\n") != -1 ? true : false;
  };
  const isCheckCharacterEnd = () => {
    return children.charCodeAt(65) === 32 ? true : false
  }
  const formatMessageNote = (message) => {
    const newText = message
      .split("\n")
      .map((str) => <div key={str + 1}>{str + " "}</div>);
    return newText;
  }
  const isTooManyCharacterDownTheLine = () => {
    const isCheck = children.split("\n");
    if(isCheck.length > 3) {
      return true;
    } else {
      return false;
    }
  }
  return (
    <div>
      <Truncate
        lines={!expanded && lines}
        trimWhitespace
        ellipsis={
          <span>
            ...{" "}
            <a href="#" onClick={toggleLines} style={{width: '90px', fontWeight: 600}}>
              {more}
            </a>
          </span>
        }
        onTruncate={handleTruncate}
        style={{wordBreak: isCharacterDownTheLine ? isCheckCharacterEnd ? !expanded ? !isTooManyCharacterDownTheLine ? "" :  "break-all" : "break-word" : "" : "break-all"}}
      >
        {isCharacterDownTheLine ?  isCheckCharacterEnd ? !expanded ? !isTooManyCharacterDownTheLine ? formatMessageNote(children) : formatMessageNote(children) : formatMessageNote(children) : formatMessageNote(children) : children}
      </Truncate>
      {!isTruncated && expanded && (
        <span>
          {" "}
          <a href="#" onClick={toggleLines} style={{width: '90px', fontWeight: 600}}>
            {less}
          </a>
        </span>
      )}
    </div>
  );
};

ReadMore.defaultProps = {
  lines: 3,
  more: "Read more",
  less: "Show less",
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
};

export default ReadMore;
